// Shared by the editable requirements form and its print summary.
export const getHCConfigurationFlags = (stationConfiguration) => ({
  isBoosterOrFloodedSuction: stationConfiguration === 'Booster' || stationConfiguration === 'Flooded Suction',
  isSuctionLift: stationConfiguration === 'Suction Lift',
});
